module.exports = __webpack_public_path__ + "img/u1016.8e719f9a.png";